export const GET_BLOGS_REQUEST = "BLOG.GET_BLOGS_REQUEST";
export const GET_BLOGS_SUCCESS = "BLOG.GET_BLOGS_SUCCESS";
export const GET_BLOGS_FAILURE = "BLOG.GET_BLOGS_FAILURE";

export const GET_BLOG_REQUEST = "BLOG.GET_BLOG_REQUEST";
export const GET_BLOG_SUCCESS = "BLOG.GET_BLOG_SUCCESS";
export const GET_BLOG_FAILURE = "BLOG.GET_BLOG_FAILURE";

export const BLOG_REACTION_REQUEST = "BLOG.REACTION_REQUEST";
export const BLOG_REACTION_SUCCESS = "BLOG.REACTION_SUCCESS";
export const BLOG_REACTION_FAILURE = "BLOG.REACTION_FAILURE";

export const BLOG_REVIEW_REQUEST = "BLOG.REVIEW_REQUEST";
export const BLOG_REVIEW_SUCCESS = "BLOG.REVIEW_SUCCESS";
export const BLOG_REVIEW_FAILURE = "BLOG.REVIEW_FAILURE";

export const GET_OWNER_BLOGS_REQUEST = "BLOG.GET_OWNER_BLOGS_REQUEST";
export const GET_OWNER_BLOGS_SUCCESS = "BLOG.GET_OWNER_BLOGS_SUCCESS";
export const GET_OWNER_BLOGS_FAILURE = "BLOG.GET_OWNER_BLOGS_FAILURE";

export const DELETE_BLOG_REQUEST = "BLOG.DELETE_BLOG_REQUEST";
export const DELETE_BLOG_SUCCESS = "BLOG.DELETE_BLOG_SUCCESS";
export const DELETE_BLOG_FAILURE = "BLOG.DELETE_BLOG_FAILURE";

export const UPDATE_BLOG_REQUEST = "BLOG.UPDATE_BLOG_REQUEST";
export const UPDATE_BLOG_SUCCESS = "BLOG.UPDATE_BLOG_SUCCESS";
export const UPDATE_BLOG_FAILURE = "BLOG.UPDATE_BLOG_FAILURE";
